import { Input } from "antd";

export default function Search({ onSearch }) {
  return (
    <Input.Search
      placeholder="Search by Customer Name or ID"
      allowClear
      onSearch={onSearch}
      enterButton="Search"
    />
  );
}
